import React from "react";
import Navauth from "../partials/navauth";
import { NavLink } from "react-router-dom";
import contact from "../../images/contact.png";

const password = () => {
  return (
    <div>
      <Navauth />
      <div>
        <div className="landing-row lg:px-[180px]">
          <div className="col-lg-12 pt-24">
            <div className="flex lg:flex-row md:flex-row md:justify-between flex-col justify-start lg:justify-between lg:items-center">
              <h3 className="header-signup lg:text-[30px] text-[22px] whitespace-nowrap md:text-[40px]">
                Reset Password
              </h3>{" "}
              <span className="terms flex items-center">
                <img
                  src={contact}
                  className="img-fluid contact"
                  alt="contact"
                />
                Contact Support
              </span>
            </div>
            <div className="row padding-form">
              <div className="flex lg:flex-row md:flex-row md:justify-between flex-col justify-between items-center">
                <div className="col-md-6 col-12">
                  <input
                    className="input-z"
                    placeholder="Enter Email or Username"
                    type="text"
                  />
                </div>

                <div className="col-md-6 col-12">
                  <p className="descriptions text-[15px] lg:text-[19px]">
                    Enter your registered Username or Email address to begin
                    with Password reset
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-12 mt-12">
                <p className="forgot">
                  Already have an Account?{" "}
                  <span className="terms">
                    {" "}
                    <NavLink to="/login" className="login">
                      {" "}
                      Login{" "}
                    </NavLink>
                  </span>
                </p>
              </div>

              <div className="col-md-6 col-12 justify-center lg:justify-end flex lg:mt-6">
                <NavLink to="/otp">
                  <button className="btn-cuppy">Reset Password</button>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default password;
